/* Yummy Gummy — Ingredients drawer open/close.
   Same shape as assets/pdp-facts-drawer.js (which mirrors cart-drawer.js):
   class-toggle + a yielded frame so the transition triggers, trapFocus/
   removeTrapFocus from global.js, the .overflow-hidden body-lock utility.
   Separate file because this is a separate drawer with its own trigger —
   the Supplement Facts one is untouched. */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-pdp-ing-drawer]');
    var triggers = document.querySelectorAll('[data-pdp-ing-trigger]');
    if (!drawer || !triggers.length) return;

    var panel = drawer.querySelector('.pdp-id__panel');
    var openedBy = null;
    var scrollY = 0;

    function open(event) {
      openedBy = (event && event.currentTarget) || triggers[0];
      drawer.hidden = false;
      // The transition doesn't reliably fire without yielding a frame first.
      window.setTimeout(function () {
        drawer.classList.add('is-active');
      });
      // .overflow-hidden makes the browser forget the scroll position, so it
      // is held here and restored on close — otherwise closing the drawer
      // drops the reader at the top of the page.
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.classList.add('overflow-hidden');

      drawer.addEventListener(
        'transitionend',
        function () {
          if (typeof trapFocus === 'function') trapFocus(panel, panel);
        },
        { once: true }
      );
    }

    function close() {
      drawer.classList.remove('is-active');
      document.body.classList.remove('overflow-hidden');

      // Focus first, scroll last: removeTrapFocus calls .focus() without
      // preventScroll, so it scrolls the trigger into view. Restoring the
      // position before that would simply be undone by it. The rAF lands
      // after the browser's own scroll-into-view.
      if (typeof removeTrapFocus === 'function') removeTrapFocus(openedBy);
      window.scrollTo(0, scrollY);
      window.requestAnimationFrame(function () { window.scrollTo(0, scrollY); });

      drawer.addEventListener(
        'transitionend',
        function () {
          if (!drawer.classList.contains('is-active')) drawer.hidden = true;
        },
        { once: true }
      );
    }

    /* Guarded per element, not once on the drawer: a trigger can arrive
       after the drawer does — the "View all ingredients" button lives in a
       separate section (pdp-ingredients-interactive), which the Theme
       Editor re-renders on its own, firing shopify:section:load again. A
       single drawer-level flag would return early on that pass and leave
       the new button unbound until a full page reload. */
    triggers.forEach(function (t) {
      if (t.__pdpIngBound) return;
      t.__pdpIngBound = true;
      t.addEventListener('click', open);
    });

    if (drawer.__pdpIngBound) return;
    drawer.__pdpIngBound = true;

    drawer.querySelectorAll('[data-pdp-ing-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    drawer.addEventListener('keyup', function (e) {
      if (e.code === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
